module.exports = __webpack_public_path__ + "img/1.a31cccd0.png";